
import { getSavedState } from './localStorage'

const CCPUser = getSavedState("CCPUser")

export const isAuthenticated = () => {
    return Object.keys(CCPUser).length > 0
}
